import { render, staticRenderFns } from "./BusMarshalRoute.vue?vue&type=template&id=4a1758c4&scoped=true"
import script from "./BusMarshalRoute.vue?vue&type=script&lang=js"
export * from "./BusMarshalRoute.vue?vue&type=script&lang=js"
import style0 from "./BusMarshalRoute.vue?vue&type=style&index=0&id=4a1758c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1758c4",
  null
  
)

export default component.exports